import { render, staticRenderFns } from "./KabSarmi.vue?vue&type=template&id=4be91976"
import script from "./KabSarmi.vue?vue&type=script&lang=js"
export * from "./KabSarmi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports